import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=5f0d6688&"
import script from "./LinkInput.vue?vue&type=script&lang=js&"
export * from "./LinkInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports